import { INFORMATION_PATH } from 'users/navigation';

module.exports = {
  path: INFORMATION_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/UserInformation'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/users/routes/show/routes/information/index.js